export type M30_SQL = {
  "m30id": number,
  "year": string | null,
  "prodname": string | null,
  "dldate": Date | null,
  "taxnum": string | null,
  "email"?: string | null,
  "infos"?: {
    "basedata": {
      "db": string | null,
      "usid": string | null,
      "conid": string | null,
      "email": string | null,
      "usname": string | null,
      "famname": string | null
    }[],
    "downloads"?: any[]
  } | null,
  "doc": string | null
}

export class M30 {
  m30id: number;
  year: number | null;
  prodname: string | null;
  downloadDate: Date | null;
  taxnum: string | null;
  email?: string | null;
  infos?: {
    usid: number | null;
    conid: number | null;
    email: string | null;
    userName: string | null;
    familyName: string | null;
  }[];
  pdf: Blob | null;

  mailStatus: 'not-sent' | 'sending' | 'sent' | 'error';

  constructor(m30: M30_SQL) {
    // parse m30 and assign values
    const parsed = M30.parse(m30);
    this.m30id = parsed.m30id;
    this.year = parsed.year;
    this.prodname = parsed.prodname;
    this.downloadDate = parsed.downloadDate;
    this.taxnum = parsed.taxnum;
    this.email = parsed.email;
    this.infos = parsed.infos;
    this.pdf = parsed.pdf;

    this.mailStatus = parsed.mailStatus;
  }

  static parse(data: M30_SQL): M30 {
    return {
      m30id: data.m30id,
      year: data.year ? parseInt(data.year, 10) : null,
      prodname: data.prodname || null,
      downloadDate: data.dldate ? new Date(data.dldate) : null,
      taxnum: data.taxnum || null,
      email: data.email || null,
      infos: data.infos?.basedata?.map((info) => ({
        usid: info.usid ? parseInt(info.usid, 10) : null,
        conid: info.conid ? parseInt(info.conid, 10) : null,
        email: info.email || null,
        userName: info.usname || null,
        familyName: info.famname || null,
      })),
      // blob from hexa coded string ("\\xA1B2FF..."))
      pdf: toPdfBlob(data.doc),

      mailStatus: 'not-sent',
    };
  }
  
}
export function toPdfBlob(str: string | null): Blob | null {
  if (!str) {
    return null;
  }
  var hexStr = str.slice(2);
  var buf = new ArrayBuffer(hexStr.length / 2);
  var byteBuf = new Uint8Array(buf);
  for (let i = 0; i < hexStr.length; i += 2) {
    byteBuf[i / 2] = parseInt(hexStr.slice(i, i + 2), 16);
  }
  var blob = new Blob([byteBuf], { type: "application/pdf" });
  return blob;
}

export interface M30_Params {
  _taxnum?: string | null
}